import type { MapItemCard } from "../../@types/mapviewxs";
import { getPropsForClickTracking } from "../../utils/tracking";
export interface Input {
  itemCard?: MapItemCard;
  isPrev?: boolean;
}

<if(input.itemCard)>
  <div data-testid="map-item" class=["map-item", input.isPrev && "prev"]>
    <div class="map-item-image-container">
      <img class="map-item-image" src=(input.itemCard.card.image?.URL) alt=(input.itemCard.card.title?.textSpans?.[0].text)>
    </div>
    <div class="map-item-content-container">
      <if(input.itemCard.sponsored)>
        <div class="map-item-sponsored-label">
          <fe-textual-display model=(input.itemCard.sponsored)/>
        </div>
      </if>
      <a
        rel="noreferrer"
        target="_blank"
        class="map-item-title"
        title=(input.itemCard.card.title?.textSpans?.[0].text)
        href=(input.itemCard.card.action?.URL)
        ...getPropsForClickTracking(input.itemCard.trackingList)
      >
        <span class="action-expand"/>
        <fe-textual-display model=(input.itemCard.card.title)/>
      </a>
      <div class="map-item-details">
        <fe-textual-display model=(input.itemCard.signalling)/>
      </div>
      <div class="map-item-price">
        <fe-textual-display model=(input.itemCard.card.displayPrice)/>
      </div>
      <if(input.itemCard.card.distance)>

        <div class="map-item-distance">
          <fe-textual-display model=(input.itemCard.card.distance)/>
        </div>
      </if>
    </div>
  </div>
</if>
